<app-navbar></app-navbar>

<main class="min-h-screen">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
